/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface KpiOverviewData
 */
export interface KpiOverviewData {
    /**
     * 
     * @type {number}
     * @memberof KpiOverviewData
     */
    customerOrderCount: number;
    /**
     * 
     * @type {number}
     * @memberof KpiOverviewData
     */
    salesOrderItemAvailabilityCount: number;
    /**
     * 
     * @type {number}
     * @memberof KpiOverviewData
     */
    invoiceCount: number;
    /**
     * 
     * @type {number}
     * @memberof KpiOverviewData
     */
    creditNotesCount: number;
}

/**
 * Check if a given object implements the KpiOverviewData interface.
 */
export function instanceOfKpiOverviewData(value: object): value is KpiOverviewData {
    if (!('customerOrderCount' in value) || value['customerOrderCount'] === undefined) return false;
    if (!('salesOrderItemAvailabilityCount' in value) || value['salesOrderItemAvailabilityCount'] === undefined) return false;
    if (!('invoiceCount' in value) || value['invoiceCount'] === undefined) return false;
    if (!('creditNotesCount' in value) || value['creditNotesCount'] === undefined) return false;
    return true;
}

export function KpiOverviewDataFromJSON(json: any): KpiOverviewData {
    return KpiOverviewDataFromJSONTyped(json, false);
}

export function KpiOverviewDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): KpiOverviewData {
    if (json == null) {
        return json;
    }
    return {
        
        'customerOrderCount': json['customerOrderCount'],
        'salesOrderItemAvailabilityCount': json['salesOrderItemAvailabilityCount'],
        'invoiceCount': json['invoiceCount'],
        'creditNotesCount': json['creditNotesCount'],
    };
}

export function KpiOverviewDataToJSON(json: any): KpiOverviewData {
    return KpiOverviewDataToJSONTyped(json, false);
}

export function KpiOverviewDataToJSONTyped(value?: KpiOverviewData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'customerOrderCount': value['customerOrderCount'],
        'salesOrderItemAvailabilityCount': value['salesOrderItemAvailabilityCount'],
        'invoiceCount': value['invoiceCount'],
        'creditNotesCount': value['creditNotesCount'],
    };
}

